<script setup lang="ts">
//Stores

//Props
import { computed } from 'vue'
import HelpButton from '@/components/common/help/HelpButton.vue'

interface Props {
  title?: string
  subtitle?: string
  addTitleClasses?: string
  addClasses?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  subtitle: '',
})

const titleClasses = computed(() => {
  const classes: string[] = ['text-2xl font-bold']
  if (props.addTitleClasses) classes.push(props.addTitleClasses)

  return classes
})

const divClasses = computed(() => {
  const classes: string[] = [
    'flex flex-col items-center justify-center sm:items-start sm:justify-start gap-2',
  ]
  if (props.addClasses) classes.push(props.addClasses)

  return classes
})
</script>

<template>
  <div :class="divClasses">
    <div class="flex items-center gap-1">
      <p :class="titleClasses">{{ props.title }}</p>
      <HelpButton />
    </div>
    <h3 v-if="props.subtitle">{{ props.subtitle }}</h3>
  </div>
</template>

<style scoped></style>
